<template>
  <div class="container">
    <div class="title">
      <span>农村综合产权交易数据</span>
    </div>
    <div class="data-list">
      <div class="data-item">
        <div class="value" style="width: 250px;text-align: left;">
          {{ formatNumber(transactionData.totalTransactionAmount) }}<span>万元</span>
        </div>
        <div class="key">交易总额</div>
      </div>
      <div class="data-item">
        <div class="value">{{ formatNumber(transactionData.totalTransactionTotal) }}</div>
        <div class="key">交易总宗数</div>
      </div>
      <div class="data-item">
        <div class="value">
          {{ formatNumber(transactionData.totalCollectiveIncome) }}<span>万元</span>
        </div>
        <div class="key">村集体增收总额</div>
      </div>
      <div class="data-item">
        <div class="value">{{ transactionData.listingCoverageRate }}%</div>
        <div class="key">标的挂牌覆盖率</div>
      </div>
      <div class="data-item">
        <div class="value">{{ formatNumber(transactionData.realTimeListingCount) }}</div>
        <div class="key">实时挂牌标的数</div>
      </div>
    </div>
    <!-- <div class="charts-wrapper">
      <div class="chart-box pie-box">
        <div id="TransactionPieChart"></div>
      </div>
      <div class="chart-box bar-box">
        <div id="TransactionBarChart"></div>
      </div>
    </div> -->
  </div>
</template>
<script>
import * as echarts from 'echarts'
import {
  ruralPropertyTransactionData,
  chartBarList,
  chartPieList,
} from '@/api/agriculture-dashboard'

export default {
  data() {
    return {
      pieChart: null,
      barChart: null,
      transactionData: {
        collectiveResourceRate: '',
        createTime: '',
        id: 0,
        listingCoverageRate: '',
        realTimeListingCount: 0,
        totalCollectiveIncome: 0,
        totalTransactionAmount: 0,
        totalTransactionTotal: 0,
        updateTime: '',
      },
      pieData: [
        { name: '集体资源类', value: 29, itemStyle: { color: '#00D4DB' } },
        { name: '集体资产类', value: 29, itemStyle: { color: '#8B5CF6' } },
        { name: '工程服务类', value: 29, itemStyle: { color: '#3B82F6' } },
        { name: '特色延伸类', value: 29, itemStyle: { color: '#F59E0B' } },
      ],
      barData: {
        categories: [
          '耕地经营权流转',
          '经营性资产租赁',
          '村级小额工程招投标',
          '果园/园地经营权流转',
          '水面养殖权流转',
        ],
        values: [260, 430, 470, 520, 570],
      },
    }
  },
  mounted() {
    this.fetchData()
    this.fetchChartData()
    this.handleResize = () => {
      this.pieChart && this.pieChart.resize()
      this.barChart && this.barChart.resize()
    }
    window.addEventListener('resize', this.handleResize)
    this.pollingTimer = setInterval(() => {
      this.fetchData()
      this.fetchChartData()
    }, process.env.VUE_APP_LTIME)
  },
  beforeDestroy() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
    }
    window.removeEventListener('resize', this.handleResize)
    if (this.pieChart) {
      this.pieChart.dispose()
      this.pieChart = null
    }
    if (this.barChart) {
      this.barChart.dispose()
      this.barChart = null
    }
  },
  methods: {
    async fetchData() {
      try {
        const res = await ruralPropertyTransactionData({})
        if (res.code === 0 && res.data) {
          this.transactionData = res.data
        }
      } catch (error) {
        console.error('获取农村综合产权交易数据失败:', error)
      }
    },
    async fetchChartData() {
      try {
        // 并行获取饼图和柱状图数据
        const [pieRes, barRes] = await Promise.all([chartPieList({}), chartBarList({})])

        // 处理饼图数据
        if (pieRes.code === 0 && pieRes.data && pieRes.data.length > 0) {
          this.updatePieChart(pieRes.data)
        } else {
          this.initPieChart()
        }

        // 处理柱状图数据
        if (barRes.code === 0 && barRes.data && barRes.data.length > 0) {
          this.updateBarChart(barRes.data)
        } else {
          this.initBarChart()
        }
      } catch (error) {
        console.error('获取图表数据失败:', error)
        this.initPieChart()
        this.initBarChart()
      }
    },
    formatNumber(num) {
      if (num === null || num === undefined || num === '') return '0'
      return String(num)
    },
    updatePieChart(data) {
      // 根据接口返回数据更新饼图
      const colors = ['#00D4DB', '#8B5CF6', '#3B82F6', '#F59E0B', '#10B981', '#FF6B35']
      this.pieData = data.map((item, index) => ({
        name: item.name || '',
        value: parseFloat(item.dataValue) || 0,
        itemStyle: { color: colors[index % colors.length] },
      }))
      this.initPieChart()
    },
    updateBarChart(data) {
      // 根据接口返回数据更新柱状图
      this.barData.categories = data.map(item => item.name || '')
      this.barData.values = data.map(item => parseFloat(item.dataValue) || 0)
      this.initBarChart()
    },
    initPieChart() {
      if (!this.pieChart) {
        this.pieChart = echarts.init(document.getElementById('TransactionPieChart'))
      }
      const option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(5, 13, 76, 0.9)',
          borderColor: '#00C0FE',
          borderWidth: 1,
          textStyle: {
            fontSize: 14,
            color: '#fff',
          },
          formatter: params => {
            return `<div style="font-size:14px;color:#00C0FE;margin-bottom:4px">${params.name}</div>
                    <div style="font-size:16px;font-weight:bold;color:#fff">占比: ${params.value}%</div>`
          },
        },
        legend: {
          orient: 'horizontal',
          bottom: 0,
          left: 'center',
          width: 400,
          itemWidth: 20,
          itemHeight: 20,
          itemGap: 20,
          textStyle: {
            fontSize: 20,
            color: '#FFFFFF',
          },
        },
        series: [
          {
            name: '交易类型',
            type: 'pie',
            radius: ['0%', '65%'],
            center: ['50%', '45%'],
            roseType: 'radius',
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 4,
              borderColor: 'rgba(5, 13, 76, 0.5)',
              borderWidth: 2,
            },
            label: {
              show: true,
              position: 'inside',
              formatter: '{c}%',
              fontSize: 14,
              fontWeight: 'bold',
              color: '#fff',
            },
            emphasis: {
              scale: true,
              scaleSize: 8,
              itemStyle: {
                shadowBlur: 20,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 192, 254, 0.5)',
              },
            },
            data: this.pieData,
          },
        ],
      }
      this.pieChart.setOption(option)
    },
    initBarChart() {
      if (!this.barChart) {
        this.barChart = echarts.init(document.getElementById('TransactionBarChart'))
      }
      const barColors = ['#FF6B35', '#F59E0B', '#00D4DB', '#3B82F6', '#10B981']

      const formattedData = this.barData.values.map((value, index) => {
        return {
          value,
          itemStyle: {
            color: barColors[index % barColors.length],
          },
        }
      })

      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(5, 13, 76, 0.9)',
          borderColor: '#00c0fe',
          borderWidth: 1,
          textStyle: {
            fontSize: 14,
            color: '#fff',
          },
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: 'rgba(0, 192, 254, 0.1)',
            },
          },
          formatter: params => {
            const data = params[0]
            return `
              <div style="padding: 8px;">
                <div style="font-size: 14px; color: #899dbf; margin-bottom: 4px;">${data.name}</div>
                <div style="font-size: 16px; font-weight: bold; color: #00C0FE;">${data.value}</div>
              </div>
            `
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: this.barData.categories,
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 16,
            color: '#FFFFFF',
            interval: 0,
            lineHeight: 38,
            rotate: 20,
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)',
              type: 'dashed',
            },
          },
          axisLabel: {
            fontSize: 20,
            color: 'rgba(255, 255, 255, 0.7)',
          },
        },
        series: [
          {
            name: '数值',
            type: 'bar',
            barWidth: 57,
            data: formattedData,
            emphasis: {
              itemStyle: {
                shadowBlur: 20,
                shadowColor: 'rgba(0, 192, 254, 0.8)',
              },
            },
            animationDuration: 1500,
            animationEasing: 'elasticOut',
          },
        ],
      }
      this.barChart.setOption(option)
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  position: relative;
  width: 100%;
  height: 70px;
  border-radius: 7px 7px 0px 0px;
  font-weight: bold;
  font-size: 30px;
  color: #fefefe;
  line-height: 70px;
  padding-left: 22px;

  span {
    position: relative;
    z-index: 9;
  }

  &::after {
    z-index: 8;
    content: '';
    position: absolute;
    left: 0;
    bottom: 5px;
    width: 366px;
    height: 23px;
    background: url('~@/img/agriculture/title_line.png') 100% 100%;
  }
}
.data-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 21px;
  padding: 0 36px;
  margin-bottom: 0;
  .data-item {
    width: 165px;
    height: 86px;
    background: url('~@/img/agriculture/data_bg.png') no-repeat;
    .value {
      white-space: nowrap;
      text-align: center;
      font-style: italic;
      font-weight: bold;
      font-size: 34px;
      color: #ffffff;
      text-shadow: 0 2px 8px rgba(8, 141, 218, 0.4);
      background: linear-gradient(180deg, #ffffff 0%, #ffffff 40%, #5bc0f8 80%, #088dda 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      span {
        font-size: 11px;
        background: linear-gradient(180deg, #ffffff 0%, #ffffff 40%, #5bc0f8 80%, #088dda 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
    }
    .key {
      font-weight: 400;
      font-size: 16px;
      color: #89daff;
      line-height: 17px;
      text-align: center;
    }
  }
}
.charts-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  height: 380px;
  margin-top: 20px;

  .chart-box {
    height: 100%;
  }

  .pie-box {
    width: 42%;

    #TransactionPieChart {
      width: 100%;
      height: 100%;
    }
  }

  .bar-box {
    width: 56%;

    #TransactionBarChart {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
